/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookEventCreateRequestBaseResponse as ModelsWebhookWebhookEventCreateRequestBaseResponse } from '../../models/Models/Webhook/webhook-event-create-request-base-response';

export interface V3WebhooksDeregisterDelete$Json$Params {
}

export function v3WebhooksDeregisterDelete$Json(http: HttpClient, rootUrl: string, params?: V3WebhooksDeregisterDelete$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3WebhooksDeregisterDelete$Json.PATH, 'delete');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsWebhookWebhookEventCreateRequestBaseResponse>;
    })
  );
}

v3WebhooksDeregisterDelete$Json.PATH = '/v3/webhooks/deregister';
